import { FC } from 'react';

import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';

import { MobileTooltipBottomSheet } from 'components/CampaignsDashboard/components/CampaignsTable/components/MobileTooltipBottomSheet';

interface MobileTableHeaderTooltipProps {
    title: string;
    tooltipText: string;
    dataQa: string;
}

export const MobileTableHeaderTooltip: FC<MobileTableHeaderTooltipProps> = ({ title, tooltipText, dataQa }) => {
    const [isBottomSheetVisible, setIsBottomSheetVisibleOn, setIsBottomSheetVisibleOff] = useOnOffState(false);

    return (
        <>
            <QuestionCircleOutlinedSize16
                initialColor="secondary"
                onClick={setIsBottomSheetVisibleOn}
                data-qa={`${dataQa}-activator`}
            />
            <MobileTooltipBottomSheet
                visible={isBottomSheetVisible}
                onClose={setIsBottomSheetVisibleOff}
                title={title}
                dataQa={`${dataQa}-bottom-sheet`}
            >
                {tooltipText}
            </MobileTooltipBottomSheet>
        </>
    );
};
